if (!customElements.get('wls-media-testimonials')) {
  class WLSMediaTestimonials extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        mediaTestimonialsSlider: 'js-wls-media-testimonials-slider',
        sectionId: `${this.getAttribute('data-section-id')}`,
      };

      this.selectors = {
        mediaTestimonialsSlider: this.querySelector(`.${this.classes.mediaTestimonialsSlider}`),
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      this.initializeSwiper();
    }

    /**
     * Initialize Swiper.
     *
     * @returns {void}
     */
    initializeSwiper() {
      const settingsElement = document.getElementById(`CarouselSettings-${this.classes.sectionId}`);
      const settings = JSON.parse(settingsElement.textContent);

      new Swiper(this.selectors.mediaTestimonialsSlider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: settings.animationSpeed || 3000,
          disableOnInteraction: false,
        },
      });
    }
  }

  window.customElements.define('wls-media-testimonials', WLSMediaTestimonials);
}
